import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ObjectApiInterface } from '../../../../core/base/interfaces/object-api.interface';

export interface SupplierApiKeyModel {
  _id: string;
  label: string;
  supplier: { _id: string; label: string; technicalIdentifier: string };
  tenant: { _id: string; label: string; technicalIdentifier: string };
  lastUsedAt?: string;
  revokedAt?: string;
  revokedBy?: { _id: string; firstName: string; lastName: string };
  createdAt: string;
  updatedAt: string;
  technicalIdentifier: string;
}

export interface SupplierApiKeyCreateDto {
  label: string;
}

export interface GenerateApiKeyResponse {
  apiKey: string;
  document: SupplierApiKeyModel;
}

@Injectable({
  providedIn: 'root',
})
export class SupplierApiKeyService {
  private readonly baseUrl = '/api/supplier';

  constructor(private readonly http: HttpClient) {}

  generateApiKey(
    supplierId: string,
    dto: SupplierApiKeyCreateDto,
  ): Observable<ObjectApiInterface<GenerateApiKeyResponse>> {
    return this.http.post<ObjectApiInterface<GenerateApiKeyResponse>>(
      `${this.baseUrl}/${supplierId}/api-key/generate`,
      dto,
    );
  }

  /** Génère une clé et ne renvoie que sa valeur en clair, affichable une seule fois. */
  generateApiKeyValue(supplierId: string, dto: SupplierApiKeyCreateDto): Observable<string> {
    return this.generateApiKey(supplierId, dto).pipe(map(res => ((res as any).data ?? res).apiKey));
  }

  findAll(
    supplierId: string,
    sortField = 'createdAt',
    sortOrder = 'desc',
  ): Observable<ObjectApiInterface<SupplierApiKeyModel[]>> {
    return this.http.get<ObjectApiInterface<SupplierApiKeyModel[]>>(`${this.baseUrl}/${supplierId}/api-key/list`, {
      params: { sort: `${sortField}@${sortOrder}` },
    });
  }

  revokeApiKey(supplierId: string, apiKeyId: string): Observable<ObjectApiInterface<SupplierApiKeyModel>> {
    return this.http.put<ObjectApiInterface<SupplierApiKeyModel>>(
      `${this.baseUrl}/${supplierId}/api-key/${apiKeyId}/revoke`,
      {},
    );
  }

  deleteApiKey(supplierId: string, apiKeyId: string): Observable<ObjectApiInterface<void>> {
    return this.http.delete<ObjectApiInterface<void>>(`${this.baseUrl}/${supplierId}/api-key/${apiKeyId}`);
  }
}
